<template>
    <section class="orig-backup">
    <div class="div-block-1934">
      <div class="w-layout-blockcontainer w-container">
        <div class="logo-nav-div">
          <a href="#" class="w-inline-block"><img sizes="84.03125px" srcset="@/assets/images/Logo-p-500.png 500w, @/assets/images/Logo-p-800.png 800w, @/assets/images/Main_Logo.png 1000w" alt="" src="@/assets/images/Main_Logo.png" loading="lazy" class="image-285"></a>
        </div>
        <div class="report-body-main-div">
          <div class="top-section-div">
            <div class="text-block-1105"><span class="text-span-239">Congrats {{ user.first_name }}! </span><br>You meet the initial pre-qualifications.<br>You are all set to <strong>lose {{user.weight - desiredWeight}} Pounds!</strong></div>
          </div>
          <div class="report-summary-div-2">
            <div class="div-block-1534">
              <div class="div-block-1537">
                <div class="text-block-575">{{user.first_name}}&#x27;s <strong>Medical Weight Loss Plan</strong></div>
              </div>
              <div class="div-block-1535">
                <div class="div-block-1536">
                  <div class="text-block-573">Your Current Weight </div>
                  <div class="text-block-574">{{user.weight}} <span class="text-span-107">lbs</span></div>
                </div>
                <div class="div-block-1536">
                  <div class="text-block-573">Your Target Weight is</div>
                  <div class="text-block-574">{{desiredWeight}} <span class="text-span-107">lbs</span></div>
                </div>
              </div>
            </div>
            <div class="div-block-1923">
              
              <div class="div-block-1917">
                <div class="div-block-1932"><chatImage :weight="user.weight" :desiredWeight="desiredWeight"/></div>
              </div>
            </div>
            <div class="div-block-1527"><p class="paragraph-111">These figures are for informational purposes only and not a guarantee of results. Your weight loss will depend on your exercise, diet, and medication adherence. Data is based on studies from the New England Journal of Medicine and research by Louis J. Aronne, MD; Naveed Sattar, MD; and Deborah B. Horn, MD.</p></div>
            <div class="div-block-1624">
              <div class="reportbox">
                <div class="table-row-div top">
                  <div class="div-block-1603"></div>
                  <div class="div-block-1604">
                    <div class="text-block-655 top">% Loss</div>
                  </div>
                  <div class="div-block-1614">
                    <div class="text-block-655 top">Weight Loss</div>
                  </div>
                  <div class="div-block-1636">
                    <div class="text-block-655 top">New Weight</div>
                  </div>
                </div>
                <div class="table-row-div" style="background: #EBEBEB;">
                  <div class="div-block-1603">
                    <div class="text-block-655">Avg. Weight Loss on <span class="text-span-241">Semaglutide</span></div>
                  </div>
                  <div class="div-block-1604">
                    <div class="text-block-637">16%</div>
                  </div>
                  <div class="div-block-1614">
                    <div class="text-block-637">{{ (parseInt(user.weight) * 0.16).toFixed(0) }} <span class="text-span-144">lbs</span></div>
                  </div>
                  <div class="div-block-1636">
                    <div class="text-block-637">{{ (parseInt(user.weight) - (parseInt(user.weight) * 0.16)).toFixed(0) }} <span class="text-span-144">lbs</span></div>
                  </div>
                </div>
                <div class="table-row-div" style="background: #EBEBEB;">
                  <div class="div-block-1603">
                    <div class="text-block-655">1 in 3 lose more on <span class="text-span-241">Semaglutide</span><br></div>
                  </div>
                  <div class="div-block-1604">
                    <div class="text-block-637">23%</div>
                  </div>
                  <div class="div-block-1614">
                    <div class="text-block-637">{{ (parseInt(user.weight) * 0.23).toFixed(0) }} <span class="text-span-144">lbs</span></div>
                  </div>
                  <div class="div-block-1636">
                    <div class="text-block-637">{{ (parseInt(user.weight) - (parseInt(user.weight) * 0.23)).toFixed(0) }} <span class="text-span-144">lbs</span></div>
                  </div>
                </div>
                <div class="table-row-div" style="background: #EBEBEB;">
                  <div class="div-block-1603">
                    <div class="text-block-655">Avg. Weight Loss on <span class="text-span-241">Tirzepatide</span></div>
                  </div>
                  <div class="div-block-1604">
                    <div class="text-block-637">22%</div>
                  </div>
                  <div class="div-block-1614">
                    <div class="text-block-637">{{ (parseInt(user.weight) * 0.22).toFixed(0) }} <span class="text-span-144">lbs</span></div>
                  </div>
                  <div class="div-block-1636">
                    <div class="text-block-637">{{ (parseInt(user.weight) - (parseInt(user.weight) * 0.22)).toFixed(0) }} <span class="text-span-144">lbs</span></div>
                  </div>
                </div>
                <div class="table-row-div bottom" style="background: #EBEBEB;">
                  <div class="div-block-1603">
                    <div class="text-block-655">1 in 3 lose more on <span class="text-span-241">Tirzepatide</span></div>
                  </div>
                  <div class="div-block-1604">
                    <div class="text-block-637">28%</div>
                  </div>
                  <div class="div-block-1614">
                    <div class="text-block-637">{{ (parseInt(user.weight) * 0.28).toFixed(0) }} <span class="text-span-144">lbs</span></div>
                  </div>
                  <div class="div-block-1636">
                    <div class="text-block-637">{{ (parseInt(user.weight) - (parseInt(user.weight) * 0.28)).toFixed(0) }} <span class="text-span-144">lbs</span></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="next-steps-div">
            <div class="next-steps-box">
              <div class="next-step-header-div">
                <div class="text-block-1113">What&#x27;s Next?</div>
                <div class="text-block-1110">You are about to join thousands losing weight with Semaglutide &amp; Tirzepatide.</div>
              </div>
              <div class="step-entry-div">
                <div class="div-block-1939"><img sizes="(max-width: 479px) 4vw, 1vw" srcset="@/assets/images/NS_SemaglutideVial-p-500.png 500w, @/assets/images/NS_SemaglutideVial.png 554w" alt="" src="@/assets/images/NS_SemaglutideVial.png" loading="lazy" class="image-498"></div>
                <div class="div-block-1937">
                  <div class="text-block-1124">Select Your Prescription</div>
                  <div class="text-block-1103">You&#x27;ll choose between Semaglutide &amp; Tirzepatide on the next page.</div>
                </div>
              </div>
              <div class="step-entry-div">
                <div class="div-block-1939"><img loading="lazy" src="@/assets/images/icon_card.png" alt="" class="image-500"></div>
                <div class="div-block-1937">
                  <div class="text-block-1124">Pre-Authorize Your Card</div>
                  <div class="text-block-1103">These medications are in high demand. We will need to pre-authorize your card today to secure your medication and telemed appointment. (Funds are held until shipment. If denied, funds will be released back to you.)</div>
                </div>
              </div>
              <div class="step-entry-div">
                <div class="div-block-1939"><img loading="lazy" src="https://cdn.prod.website-files.com/668d55c8f0b55e9fc41fd2b8/66c64417ab952fc218b77121_icon_clipboard.png" alt="" class="image-497"></div>
                <div class="div-block-1937">
                  <div class="text-block-1124">Complete The Medical Intake</div>
                  <div class="text-block-1103">Once your payment is made, we will send you an email with instructions on how to access your Priority Meds patient portal and complete a few medical questions for the doctor.</div>
                </div>
              </div>
              <div class="step-entry-div">
                <div class="div-block-1939"><img sizes="(max-width: 479px) 9vw, 3vw" srcset="@/assets/images/stepsimage_teledoc_nS-p-500.png 500w, @/assets/images/stepsimage_teledoc_nS.png 641w" alt="" src="@/assets/images/stepsimage_teledoc_nS.png" loading="lazy" class="image-502"></div>
                <div class="div-block-1937">
                  <div class="text-block-1124">Doctor&#x27;s Review</div>
                  <div class="text-block-1103">The doctor will review your chart. (Usually within 5 hours including weekends.)</div>
                </div>
              </div>
              <div class="step-entry-div last">
                <div class="div-block-1939"><img loading="lazy" src="https://cdn.prod.website-files.com/668d55c8f0b55e9fc41fd2b8/66c742632bf62043d3fad823_icon_van.png" alt=""></div>
                <div class="div-block-1937">
                  <div class="text-block-1124">Approval and Shipping</div>
                  <div class="text-block-1103">Once approved, your prescription will be filled by a Board Certified 503A compounding pharmacy licensed in your state. Your medication will be shipped overnight with temperature-controlled packaging to ensure product integrity. Most orders are processed and shipped the same day, Monday through Friday, with tracking information emailed once your order ships.</div>
                </div>
              </div>
            </div>
          </div>
          <div class="slider-table-div">
            <div class="div-block-1540">
              <div class="text-block-1109 no-highlight"><span class="text-span-238">It is {{getYear}}...</span>you have no excuse to not reach your weight goals.</div>
            </div>
            <div class="div-block-1538">
              <div data-delay="4000" data-animation="slide" class="slider-10 w-slider" data-autoplay="false" data-easing="ease" data-hide-arrows="false" data-disable-swipe="false" data-autoplay-limit="0" data-nav-spacing="3" data-duration="500" data-infinite="true">
                <div class="w-slider-mask" ref="carouselContent">
                    <div class="slide-4 w-slide" v-for="(video, index) in videos" :key="index">
                            <div class="div_vidcontainer">
                                <div class="div_bgvid">
                                    <div class="background-video w-background-video w-background-video-atom">
                                        <video :id="'video-' + index" loop :style="'background-image:url('+video.poster+';)'" muted playsinline :src="video.src" :ref="`video-${index}`" @play="updatePlayState(index, true)" @pause="updatePlayState(index, false)" :class="{ 'playing': video.isPlaying }" :poster="video.poster">
                                            <source :src="video.srcMp4" type="video/mp4" />
                                            <source :src="video.srcWebm" type="video/webm" />
                                        </video>
                                        <noscript>
                                            <img :src="video.poster" alt="Video Poster" />
                                        </noscript>
                                        <div aria-live="polite">
                                            <button type="button" @click="togglePlayPause(index)" :aria-controls="'video-' + index" class="w-backgroundvideo-backgroundvideoplaypausebutton w-background-video--control">
                                                <span v-if="!video.isPlaying">
                                                    <img src="@/assets/images/play-24.svg" alt="Play video" />
                                                </span>
                                                <span v-else>
                                                    <img src="@/assets/images/pause-circle-svgrepo-com.svg" alt="Pause video" />
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                </div>
                <div class="left-arrow-11 w-slider-arrow-left" @click="scrollLeft">
                  <div class="icon-36 w-icon-slider-left"></div>
                </div>
                <div class="right-arrow-10 w-slider-arrow-right"  @click="scrollRight">
                  <div class="icon-37 w-icon-slider-right"></div>
                </div>
                <div class="w-slider-nav w-slider-nav-invert w-round"></div>
              </div>
              <p class="paragraph-111">The individuals in this testimonial are GLP1 Weight Loss users and were compensated for their video testimonial by {{appName}}. Individual results may vary. A provider may choose to prescribe compounded GLP-1 medications, which are prepared by a state-licensed sterile compounding pharmacy but are not FDA-approved and do not undergo safety, effectiveness, or manufacturing review.</p>
            </div>
            <div class="div-block-1940">
              <div class="div-block-1933"></div>
            </div>
          </div>
          <div class="huge-savings-div">
            <div class="div-block-1633">
              <div class="text-block-672">One Price.<br>‍<span class="text-span-153">Everything included.</span></div>
            </div>
            <div class="div-block-1621">
              <div class="summary-entry-2 top">
                <div class="savings-bullet-div top"><img loading="lazy" src="@/assets/images/icon_meds.png" alt="" class="image-348 report">
                  <div class="item-detail _1 top">
                    <div class="text-block-664 report top">All Dosages the Same Low Price</div>
                    <div class="text-block-652 report">We do not charge you double like competitors when you increase your dosage.</div>
                  </div>
                </div>
              </div>
              <div class="summary-entry-2" style="background: #fff;">
                <div class="savings-bullet-div"><img loading="lazy" src="@/assets/images/icon_stetoscope.png" alt="" class="image-348 report">
                  <div class="text-block-664 report">Doctor Support<br>and Monitoring</div>
                </div>
                <div class="item-price">
                  <div class="no-discount-price step-2 report"><sup>$</sup>99</div>
                  <div class="text-block-648 report">Free</div>
                </div>
              </div>
              <!--<div class="summary-entry-2" style="background: #fff;">
                <div class="savings-bullet-div"><img loading="lazy" src="@/assets/images/icon_clipboard.png" alt="" class="image-348 report">
                  <div class="text-block-664 report">Metabolic Weight Plan &amp;<br>blood work included</div>
                </div>
                <div class="item-price">
                  <div class="no-discount-price step-2 report"><sup>$</sup>75</div>
                  <div class="text-block-648 report">Free</div>
                </div>
              </div>-->
              <div class="summary-entry-2" style="background: #fff;">
                <div class="savings-bullet-div"><img loading="lazy" src="@/assets/images/Icon_stepsDeliver.png" alt="" class="image-348 report van">
                  <div class="text-block-664 report">Free Express Shipping</div>
                </div>
                <div class="item-price">
                  <div class="no-discount-price step-2 report"><sup>$</sup>40</div>
                  <div class="text-block-648 report">Free</div>
                </div>
              </div>
              <div class="summary-entry-2" style="background: #fff;">
                <div class="savings-bullet-div"><img sizes="50px" srcset="@/assets/images/BoxImage_PhoneQuiz-p-500.png 500w, @/assets/images/BoxImage_PhoneQuiz-p-800.png 800w, @/assets/images/BoxImage_PhoneQuiz.png 1080w" alt="" src="@/assets/images/BoxImage_PhoneQuiz.png" loading="lazy" class="image-348 report van">
                  <div class="text-block-664 report">Never Pay Monthly Membership Fees</div>
                </div>
                <div class="item-price">
                  <div class="no-discount-price step-2 report"><sup>$</sup>99</div>
                  <div class="text-block-648 report">Free</div>
                </div>
              </div>
              <div class="savings-div-2"  style="background: #adff9e;"><img loading="lazy" src="@/assets/images/party-popper.png" alt="" class="image-347">
                <div class="text-block-651 report">You saved <sup>$</sup>313 on your order!</div>
              </div>
            </div>
          </div>
          <div class="testimonial-div">
            <div class="div-block-1616"><img loading="lazy" src="https://uploads-ssl.webflow.com/66ac7d81f3eb9a615c96a5be/66c29e8e2b40c08d2b354cc2_b%26a_TF01.jpg" alt="" class="image-350"></div>
            <div class="div-block-1623"><img loading="lazy" src="@/assets/images/icon_stars_1.svg" alt="" class="image-351">
              <div class="text-block-657">{{appName}} helped me achieve weight goals I never thought possible.</div>
              <p class="paragraph-119">Even as a former athlete, I still struggled to lose weight with diet alone. With GLP1s it was a matter of weeks before the weight started dropping off!</p>
              <div class="text-block-636">Michelle, lost 55 lbs.</div>
            </div>
          </div>
          <div class="expectations-div">
            <div class="text-block-1109">What You can Expect</div>
            <p class="paragraph-150">Join the millions of Americans losing weight with Semaglutide and <strong>start seeing results in as little as 4 weeks!</strong></p>
            <div class="div-block-1936">
              <div class="div-block-1928">
                <div class="div-block-1931">
                  <div class="text-block-1115">Lose weight</div>
                  <div class="text-block-1125">On average,Semaglutide & Tirzepatide users <span class="text-span-237">lose around 15% - 25%</span> of their body weight</div>
                </div>
                <div class="div-block-1931">
                  <div class="text-block-1115">Feel fuller, longer</div>
                  <div class="text-block-1125">Semaglutide and Tirzepatide <span class="text-span-237">suppresses appetite</span> and curbs food cravings**</div>
                </div>
              </div>
              <div class="div-block-1928">
                <div class="div-block-1931">
                  <div class="text-block-1115">Reduce cholesterol</div>
                  <div class="text-block-1125">GLP Medication has been shown to <span class="text-span-237">reduce total cholesterol, </span> LDL cholesterol &amp; triglycerides**</div>
                </div>
                <div class="div-block-1931">
                  <div class="text-block-1115">Improve heart health</div>
                  <div class="text-block-1125"><span class="text-span-237">Prevent heart attacks</span> and reduce the risk of major cardiac events***</div>
                </div>
              </div>
            </div>
          </div>
          <div class="testimonial-div c">
            <div class="div-block-1616"><img loading="lazy" src="https://uploads-ssl.webflow.com/66ac7d81f3eb9a615c96a5be/66c29e8ef051ca61bd69a476_b%26a_TF04.jpg" alt="" class="image-350"></div>
            <div class="div-block-1623"><img loading="lazy" src="@/assets/images/icon_stars_1.svg" alt="" class="image-351">
              <div class="text-block-657">I couldn&#x27;t imagine life without my GLP weekly routine!</div>
              <p class="paragraph-119">&quot;I went from 287 pounds all the way to to 165 pounds...all thanks to a healthier diet, exercise and most importantly my weekly injections!&quot;</p>
              <div class="text-block-636">Jason, lost 122 lbs.</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="reportstickybuttondiv">
      <div class="w-layout-blockcontainer reportbutton_container w-container">
        <router-link to="/weight-loss-plan" class="link-block-41 w-inline-block">
          <div class="text-block-665">Click Here to Start your FREE <br>Medical Weight Loss Evaluation <span class="text-span-154">-&gt;</span></div>
        </router-link>
      </div>
    </div>
  </section>
</template>

<script>
import chatImage from "./chartImage.vue"
import {
    mapGetters
} from 'vuex';
export default {
    components:{
        chatImage
    },
    data() {
        return {
            scrollAmount: 225,
            desiredWeight:120,
            appName: process.env.VUE_APP_COMPANY,
            videos: [{
                    "src": "https://uploads-ssl.webflow.com/668d55c8f0b55e9fc41fd2b8%2F66b37c962bcd847368db5528_GOOD%20Weight-Loss274-transcode.mp4",
                    "srcMp4": "https://uploads-ssl.webflow.com/668d55c8f0b55e9fc41fd2b8%2F66b37c962bcd847368db5528_GOOD%20Weight-Loss274-transcode.mp4",
                    "srcWebm": "https://uploads-ssl.webflow.com/668d55c8f0b55e9fc41fd2b8%2F66b37c962bcd847368db5528_GOOD%20Weight-Loss274-transcode.webm",
                    "poster": "https://uploads-ssl.webflow.com/668d55c8f0b55e9fc41fd2b8%2F66b37c962bcd847368db5528_GOOD%20Weight-Loss274-poster-00001.jpg",
                    "isPlaying": false
                },
                {
                    "src": "https://uploads-ssl.webflow.com/668d55c8f0b55e9fc41fd2b8%2F66b37d9e84888252c0dc1838_GOOD%20Weight-Loss289-transcode.mp4",
                    "srcMp4": "https://uploads-ssl.webflow.com/668d55c8f0b55e9fc41fd2b8%2F66b37d9e84888252c0dc1838_GOOD%20Weight-Loss289-transcode.mp4",
                    "srcWebm": "https://uploads-ssl.webflow.com/668d55c8f0b55e9fc41fd2b8%2F66b37d9e84888252c0dc1838_GOOD%20Weight-Loss289-transcode.webm",
                    "poster": "https://uploads-ssl.webflow.com/668d55c8f0b55e9fc41fd2b8%2F66b37d9e84888252c0dc1838_GOOD%20Weight-Loss289-poster-00001.jpg",
                    "isPlaying": false
                },
                {
                    "src": "https://uploads-ssl.webflow.com/668d55c8f0b55e9fc41fd2b8%2F66b37cdafac423ae4e69f502_GOOD%20Weight-Loss278-transcode.mp4",
                    "srcMp4": "https://uploads-ssl.webflow.com/668d55c8f0b55e9fc41fd2b8%2F66b37cdafac423ae4e69f502_GOOD%20Weight-Loss278-transcode.mp4",
                    "srcWebm": "https://uploads-ssl.webflow.com/668d55c8f0b55e9fc41fd2b8%2F66b37cdafac423ae4e69f502_GOOD%20Weight-Loss278-transcode.webm",
                    "poster": "https://uploads-ssl.webflow.com/668d55c8f0b55e9fc41fd2b8%2F66b37cdafac423ae4e69f502_GOOD%20Weight-Loss278-poster-00001.jpg",
                    "isPlaying": false
                },
                {
                    "src": "https://uploads-ssl.webflow.com/668d55c8f0b55e9fc41fd2b8%2F66b37d1ccfa9a8ade07d3755_GOOD%20Weight-Loss279-transcode.mp4",
                    "srcMp4": "https://uploads-ssl.webflow.com/668d55c8f0b55e9fc41fd2b8%2F66b37d1ccfa9a8ade07d3755_GOOD%20Weight-Loss279-transcode.mp4",
                    "srcWebm": "https://uploads-ssl.webflow.com/668d55c8f0b55e9fc41fd2b8%2F66b37d1ccfa9a8ade07d3755_GOOD%20Weight-Loss279-transcode.webm",
                    "poster": "https://uploads-ssl.webflow.com/668d55c8f0b55e9fc41fd2b8%2F66b37d1ccfa9a8ade07d3755_GOOD%20Weight-Loss279-poster-00001.jpg",
                    "isPlaying": false
                },
                {
                    "src": "https://uploads-ssl.webflow.com/668d55c8f0b55e9fc41fd2b8%2F66b37d50b541310f0904a443_GOOD%20Weight-Loss288-transcode.mp4",
                    "srcMp4": "https://uploads-ssl.webflow.com/668d55c8f0b55e9fc41fd2b8%2F66b37d50b541310f0904a443_GOOD%20Weight-Loss288-transcode.mp4",
                    "srcWebm": "https://uploads-ssl.webflow.com/668d55c8f0b55e9fc41fd2b8%2F66b37d50b541310f0904a443_GOOD%20Weight-Loss288-transcode.webm",
                    "poster": "https://uploads-ssl.webflow.com/668d55c8f0b55e9fc41fd2b8%2F66b37d50b541310f0904a443_GOOD%20Weight-Loss288-poster-00001.jpg",
                    "isPlaying": false
                }
            ]
        };
    },
    computed: {
        ...mapGetters([
            'user',
        ]),
        getYear() {
            return new Date().getFullYear();
        },
        isDiscountOffer() {
            return true;
        },
        getPrice() {
            let discountedPrice = 349 - this.discount;

            if (discountedPrice % 1 !== 0) {
                discountedPrice = Math.round(discountedPrice * 100) / 100;
            }
            return discountedPrice;
        },
        discount() {
            if (this.$route.query.offer == "ninetynine") {
                return 250
            } else if (this.$route.query.offer == "oneforty") {
                return 150
            }
            return 0
        }
    },
    mounted() {
      if(this.$route.query.desiredWeight){
        this.desiredWeight = this.$route.query.desiredWeight;
      }
      if (this.$refs.slider) {
          this.$refs.slider.addEventListener('touchstart', this.handleTouchStart);
          this.$refs.slider.addEventListener('touchmove', this.handleTouchMove);
          this.$refs.slider.addEventListener('touchend', this.handleTouchEnd);
      }
    },
    methods: {
        getDetails() {
            this.people.first_name = this.$route.query.name;
            this.people.weight = this.$route.query.weight;
            this.people.desired_weight = this.$route.query.goal;
        },
        handleTouchStart(event) {
            this.startX = event.touches[0].clientX;
        },
        handleTouchMove(event) {
            this.currentX = event.touches[0].clientX;
        },
        handleTouchEnd() {
            const deltaX = this.currentX - this.startX;
            if (Math.abs(deltaX) > 50) {
                if (deltaX > 0) {
                    this.scrollLeft();
                } else {
                    this.scrollRight();
                }
            }
        },
        scrollLeft() {
            const container = this.$refs.carouselContent;
            container.scrollBy({
                left: -this.scrollAmount,
                behavior: 'smooth'
            });
        },
        scrollRight() {
            const container = this.$refs.carouselContent;
            container.scrollBy({
                left: this.scrollAmount,
                behavior: 'smooth'
            });
        },
        pushToRoute(event) {
            event.preventDefault();
            if (this.$route.query.offer == "ninetynine" || this.$route.query.offer == "oneforty") {
                this.$router.push({
                    name: 'CheckoutOffer',
                    query: {
                        "health_id": this.$route.query.health_id,
                        "id": this.$route.query.id,
                        "name": this.$route.query.name,
                        "phase": 1,
                        "plan": "Semaglutide",
                        "pay_terms": 1,
                        "state": this.$route.query.state,
                        "aegate": "Mjk5",
                        "offer": this.$route.query.offer
                    }
                });
            } else {
                this.$router.push({
                    name: 'CheckoutForm',
                    query: {
                        "health_id": this.$route.query.health_id,
                        "id": this.$route.query.id,
                        "name": this.$route.query.name,
                        "phase": this.$route.query.phase,
                        "plan": this.$route.query.plan,
                        "state": this.$route.query.state,
                        "discount": this.$route.query.discount ?? 100,
                    }
                });
            }
        },
        togglePlayPause(index) {
            const videoElement = this.$refs[`video-${index}`][0];
            if (this.videos[index].isPlaying) {
                videoElement.pause();
            } else {
                videoElement.play();
            }
        },
        updatePlayState(index, isPlaying) {
            this.$set(this.videos, index, {
                ...this.videos[index],
                isPlaying
            });
        },
        scrolltoTop() {
            setTimeout(function () {
                window.scroll({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                });
            }, 100);
        },
    },
    created() {
        this.scrolltoTop();

    }
};
</script>
<style scoped>
.text-block-1115{
  background-image: none;
}
.text-block-573{
  background-color: transparent;
}
.link-block-41:hover{
  background-color: var(--greenbutton-dark);
    border-radius: 11px;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    width: auto;
    padding: 20px;
    text-decoration: none;
    display: flex
;
}
</style>